import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Radius} from "../types/Radius";

export const useGetRadii = (dealerID: number, prodQteGrpID: number, zipCode: string) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-pro-radii', prodQteGrpID, dealerID, zipCode],
        queryFn: async () => await apiClient.get('ee-pro/radii?dealerID=' + dealerID + '&prodQteGrpID=' + prodQteGrpID + '&zipCode=' + zipCode) as Radius[],
        enabled: prodQteGrpID > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
